export function canDownload(filePath) {
  return filePath.startsWith('http');
}
